<template>
    <div class="products">
        <div class="title">
            <div class="title-text"><span>产品</span>体系</div>
            <div class="title-more"><span>PRODUCTS</span><span>SYSTEM</span></div>
        </div>
        <div class="banner">
            <swiper :modules="modules" class="swiper" :navigation="true">
                <swiper-slide v-for="(slide, index) in slides" :key="index">
                    <!-- <img :src="slide.image" :alt="slide.alt" class="img" /> -->
                    <img v-lazy="productBanner" alt="">
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script setup>
import productBanner from '@/assets/images/index/productBanner.png';
import { ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Navigation, Pagination, } from 'swiper/modules';
// 引入swiper样式，对应css 如果使用less或者css只需要把scss改为对应的即可
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
const modules = [Autoplay, Navigation, Pagination,]
const slides = ref([{}, {}])
</script>

<style lang="less" scoped>
.products {
    width: 100%;
    margin-top: 6.25rem;
    padding-left: 15.3125rem;
    padding-right: 15.3125rem;
    // background-color: pink;

    .title {
        font-size: 3.125rem;
        font-weight: bold;
        position: relative;
        height: 8.75rem;

        .title-text {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: .5rem;

            span {
                &:nth-child(1) {
                    color: @xtxColor;
                }
            }
        }

        .title-more {
            font-size: 6.25rem;
            -webkit-text-stroke: 2px #3E3A39;
            opacity: 0.1;
            color: transparent; //字体颜色设置为透明
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .banner {
        width: 100%;
        height: 62.5rem;

        .swiper {
            width: 100%;
            height: 62.5rem;
            position: relative;

            :deep(.swiper-button-prev:after, .swiper-rtl .swiper-button-next:after) {
                content: none;
            }

            :deep(.swiper-button-prev) {
                width: 3.875rem;
                height: 3.875rem;
                background-image: url(@/assets/images/index/productLeft.png);
                background-size: 3.875rem auto;
                left: 39rem;
                top: 58.125rem;

                &:hover {
                    transform: scale(1.1);
                    transition: all 0.5s;
                }
            }

            :deep(.swiper-button-next:after, .swiper-rtl .swiper-button-prev:after) {
                content: none;
            }

            :deep(.swiper-button-next) {
                width: 3.875rem;
                height: 3.875rem;
                background-image: url(@/assets/images/index/productRigt.png);
                background-size: 3.875rem auto;
                right: 39rem;
                top: 58.125rem;

                &:hover {
                    transform: scale(1.1);
                    transition: all 0.5s;
                }
            }
        }

        img {
            width: 100%;
            height: 54.9375rem
        }
    }
}
</style>